export const dataCapsuleNamespace = 'bookings-uou';
//# sourceMappingURL=consts.js.map